import { render, staticRenderFns } from "./FeedImportHeaderMapping.vue?vue&type=template&id=e1d6bf78"
import script from "./FeedImportHeaderMapping.vue?vue&type=script&lang=js"
export * from "./FeedImportHeaderMapping.vue?vue&type=script&lang=js"
import style0 from "./FeedImportHeaderMapping.vue?vue&type=style&index=0&id=e1d6bf78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports